import { useAppSelector } from '../app/hooks';

// Roles allowed on the Approval API (ApprovalController: Validator, Approver, AccountOwner).
// Uploaders get a 403 there, so they must not request the pending approvals list.
const APPROVAL_ROLES = ['validator', 'approver', 'accountowner'];

/**
 * The logged-in user's roles, lower-cased. The role claim can hold several
 * comma-separated roles (e.g. "Uploader,Validator"), so never compare it directly.
 */
export const useUserRoles = (): string[] => {
  const { user } = useAppSelector((state) => state.auth);
  return String(user?.role ?? '')
    .split(',')
    .map((r) => r.trim().toLowerCase())
    .filter(Boolean);
};

/** True when the user has at least one of the given roles (case-insensitive). */
export const hasAnyRole = (roles: string[], wanted: string[]): boolean =>
  wanted.some((w) => roles.includes(w.toLowerCase()));

/** True when the logged-in user may see the pending approvals list. */
export const useCanViewApprovals = (): boolean => hasAnyRole(useUserRoles(), APPROVAL_ROLES);
